export const propertiesOrder = [
  'Clone',
  'Certification',
  'Réactivité',
  'Predicted reactivity',
  'Application',
  'Hôte',
  'Conjugué',
  'Isotype',
  'Immunogène',
  'Purification',
  'Spécificité',
  'Taille',
  'Localisation',
  'Tissus controles',
  'Pathologie',
  'Couleur',
  'Conseil',
];

export const filterItems = [
  {
    name: 'Clone',
    type: 'property',
  },
  {
    name: 'Certification',
    type: 'option',
  },
  {
    name: 'Réactivité',
    type: 'property',
  },
  {
    name: 'Predicted Reactivity',
    type: 'property',
  },
  {
    name: 'Application',
    type: 'property',
  },
  {
    name: 'Hôte',
    type: 'property',
  },
  {
    name: 'Isotype',
    type: 'property',
  },
  {
    name: 'Immunogène',
    type: 'property',
  },
  {
    name: 'Conjugué',
    type: 'property',
  },
  {
    name: 'Purification',
    type: 'property',
  },
  {
    name: 'Supplier',
    type: 'option',
  },
];

export const formatOrder = ['Concentré', "Prêt à l'emploi", 'Control Slides'];

/**
 * Return the filter items which have results in the current search query.
 * It's called facetting by the cool kids.
 * @param {*} filterStatuses
 * @param {*} properties
 * @param {*} options
 * @returns a lit of filter items
 */
export const nonEmptyFilterItems = (filterStatuses, properties, options) =>
  filterItems.filter((filter) => {
    const collection = filter.type === 'property' ? properties : options;
    const item = collection.find((localItem) => localItem.name === filter.name);
    if (!item) return false;
    const filterStatus = filterStatuses[`${filter.type}_${item.id}`];
    return (
      !filterStatus || Object.values(filterStatus).length > 0 || item.selectedValues.length > 0
    );
  });

/**
 * Return the values of a filter item that have results in the current search query.
 * It's called facetting by the cool kids.
 * @param {*} type
 * @param {*} item
 * @param {*} filterStatuses
 * @returns
 */
/* eslint-disable-next-line max-len */
export const nonEmptyFilterItemValues = (type, item, filterStatuses) => {
  const filterStatus = filterStatuses[`${type}_${item.id}`];
  return item.values.filter((value) => {
    const valueId = type === 'property' ? value : value.id;
    return !filterStatus || filterStatus[valueId] || item.selectedValues.length > 0;
  });
};
